var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
// Types
import { grey } from '../../../common/styles/colours';
// @todo: replace colours with references to theme once v1 is in
export var getDividerStylesByBorderStyle = function (borderStyle) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-style: ", ";\n  border-color: ", ";\n"], ["\n  border-style: ", ";\n  border-color: ", ";\n"])), borderStyle, borderStyle === 'dashed' ? grey[500] : grey[300]); };
var templateObject_1;
//# sourceMappingURL=getDividerStylesByBorderStyle.js.map